import React from 'react'
import PopUpContext from './PopUpContext'

export default function PopUp ({ children }) {
  const [referenceElement, setReferenceElement] = React.useState(null)
  const [active, setActive] = React.useState(false)

  const value = {
    active,
    setActive,
    setReferenceElement,
    referenceElement
  }

  return (
    <PopUpContext.Provider value={value}>
      {children}
    </PopUpContext.Provider>
  )
}
